import React, { useId, useState } from 'react';
import { ProjectScreenshot } from './ProjectScreenshot';
import './ProjectGallery.css';

const displayContexts = {
  oracle: 'Browser extension',
  'process-monitor': 'macOS terminal',
  raiinet: 'Game interface',
};

export const ProjectGallery = ({ project }) => {
  const [view, setView] = useState('graphical');
  const previewId = useId();
  const isTerminal = Boolean(project.secondaryImage) && view === 'terminal';
  const image = isTerminal ? project.secondaryImage : project.image;
  const caption = isTerminal ? project.secondaryCaption : project.caption;
  const alt = project.secondaryImage
    ? `${project.title} ${isTerminal ? 'terminal' : 'graphical'} interface`
    : `${project.title} screenshot`;

  return (
    <div className={`project-gallery project-gallery-${project.id}`}>
      {project.secondaryImage && <div className="project-gallery-toolbar">
        <span className="project-gallery-context">{displayContexts[project.id] || project.title}</span>
        <div className="project-gallery-views" role="group" aria-label={`${project.title} interface view`}>
            {['graphical', 'terminal'].map(option => (
              <button
                type="button"
                key={option}
                aria-pressed={view === option}
                aria-controls={previewId}
                onClick={() => setView(option)}
              >
                {option === 'graphical' ? 'Graphical' : 'Terminal'}
              </button>
            ))}
        </div>
      </div>}
      <figure className="project-gallery-figure" id={previewId}>
        <ProjectScreenshot src={image} alt={alt} />
        <figcaption aria-live={project.secondaryImage ? 'polite' : undefined}>{caption}</figcaption>
      </figure>
    </div>
  );
};
